/**
 * Ponto de entrada da interface (H01).
 *
 * `StrictMode` fica ligado: ele monta cada efeito duas vezes em
 * desenvolvimento, e é justamente isso que se quer aqui — a renovação de token
 * e a recuperação silenciosa TÊM de suportar montar duas vezes sem disparar dois
 * fluxos. Com rotação de refresh ligada no realm, um segundo pedido em paralelo
 * derrubaria a sessão inteira. Se quebrar sob StrictMode, quebra em produção
 * quando o usuário abrir a mesma tela duas vezes.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Aplicacao } from './aplicacao';
import '@/shared/estilo/base.css';
import { aplicarTema, lerTema } from '@/shared/lib/tema';

// O tema escolhido neste navegador, antes da primeira pintura: sem piscar o outro.
aplicarTema(lerTema());

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('A raiz da aplicação não existe no documento.');

createRoot(raiz).render(
  <StrictMode>
    <Aplicacao />
  </StrictMode>,
);
